module.exports = __webpack_public_path__ + "img/block-journal.d8849f09.png";